import Login from './containers/login.container'

const routes = [{ path: '/login', title: 'Login', component: Login }]

export default routes
